/*
 *  ___                  __                __  _ _
 *   | |_  _     _ |_ |_|_    _  _ _ _ _  /  \(_(_|. _  _
 *   | | )(_)|_|(_)| )|_|__)(|_)| (-_)_)  \__/| | ||| )(-
 *              _/           |
 */
export const form = {
  'cover-details': {
    'joint-life': null,
    'main-life-only': null,
  },
  'benefit-option': null,
  'standalone-options': {
    'death-sum-assured': null,
    'total-personal-disability-sum-assured': null,
    'illness-sum-assured': null,
  },
  'accelerated-options': {
    'death-and-total-personal-disability': null,
    'death-and-critical-illness': null,
    'death-and-total-disability-and-critical-illness': null,
  },
  'accelerated-cover-sum-assured': null,
  'funeral-cover-main-life': null,
  'update-option': null,
  'hospitalisation-units': null,
  'personal-accident-cover': {
    'personal-accident-death': null,
    'personal-accident-disability': null,
  },
  'educational-support-benefit': {
    'educational-support-premium': null,
    'educational-support-term': null,
    'educational-support-escalation': null,
  },
  'retirement-benefit': {
    'retirement-premium': null,
    'retirement-annuity-term': null,
    'retirement-escalation': null,
  },
  'funeral-cover-options': {
    'basic-ghs10000': null,
    'executive-ghs20000': null,
    'premier-ghs30000': null,
    'exclusive-ghs40000': null,
    'platinum-ghs50000': null,
  },
  'policy-term': {
    'term-ten': null,
    'term-fifteen': null,
  },
  'optional-benefits': {
    'memorial-seven-day': null,
    'memorial-forty-day': null,
    'memorial-one-year': null,
    'double-accident-benefit': null,
  },
  'asset-prevention-benefit': {
    'type-of-asset': null,
    'value-of-asset': null,
    'address-of-asset': null,
  },
  'life-assured-identification': {
    'first-names': null,
    surname: null,
    'idpassport-number': null,
    title: null,
    gender: null,
    'date-of-birth': null,
    'marital-status': null,
    ghanaian: null,
    'other-nationality': null,
    'digital-address': null,
  },
  'life-assured-identification-type': {
    dvla: null,
    passport: null,
    'voter-id': null,
    nhis: null,
    ssnit: null,
    'nia-ghana-card': null,
  },
  'life-assured-contact-details': {
    'cell-phone': null,
    email: null,
  },
  'life-assured-postal-address': {
    addressee: null,
    'po-box-or-private-bag': null,
    town: null,
    region: null,
  },
  'life-assured-residential-address': {
    street: null,
    suburb: null,
  },
  'life-assured-digital-address': null,
  'life-assured-employment-details': {
    'employer-organisation': null,
    'employee-number': null,
    'basic-earnings': null,
    occupation: null,
  },
  'trustee-identification': {
    'first-names': null,
    surname: null,
    'date-of-birth': null,
    title: null,
    relationship: null,
  },
  'trustee-contact-details': {
    'cell-phone': null,
  },
  'spouse-identification': {
    'first-names': null,
    surname: null,
    'date-of-birth': null,
    'idpassport-number': null,
    gender: null,
    title: null,
  },
  'spouse-contact-details': {
    'cell-phone': null,
  },
  'spouse-identification-type': {
    dvla: null,
    passport: null,
    'voter-id': null,
    nhis: null,
    ssnit: null,
    'nia-ghana-card': null,
  },
  'spouse-employment-details': {
    'employee-number': null,
    'employer-organisation': null,
    occupation: null,
  },
  'spouse-is-trustee': null,
  'beneficiary-details': [],
  'additional-lives': [],
  'life-assured-general-habits': {
    'planning-other-insurance': null,
    'planning-other-insurance-details': null,
    'other-assurance-past12-months': null,
    'other-assurance-past12-months-details': null,
    'cover-exceeds-one-hundred-thousand': null,
    'average-monthly-gross-income': null,
    'total-existing-assurance-cover-in-force-on-your-life': null,
    'full-reasons-for-effecting-this-additional-cover': null,
    'risky-occupation-hobbies': null,
    'risky-occupation-hobbies-details': null,
    'refused-application-or-increased-premium': null,
    'refused-application-or-increased-premium-details': null,
    'insolvency-issues': null,
    'insolvency-issues-details': null,
    'occupation-not-clerical': null,
    'occupation-not-clerical-details': null,
    smoker: null,
    'non-smoker': null,
    'never-smoked': null,
    'years-smoking': null,
    'years-not-smoking': null,
    'cigarettes-per-day': null,
    'cigars-per-day': null,
    pipe: null,
    'medical-advice-stop-smoking': null,
    'medical-advice-reduce-drinking': null,
    'excessive-drinking': null,
    'excessive-drinking-past': null,
  },
  'life-assured-health-details': {
    'surgery-last-five-years': null,
    'medical-tests-last-five-years': null,
    disability: null,
    'assurance-risk': null,
    pregnant: null,
    'family-history-of-illness': null,
    'family-history-of-illness-details': null,
    'close-family-early-death': null,
    'height-cm': null,
    'mass-weight-in-kg': null,
    'chest-pain': null,
    'high-blood-pressure': null,
    'respiratory-condition': null,
    'digestive-condition': null,
    'urinary-condition': null,
    'anxiety-epilepsy': null,
    diabetes: null,
    'cancer-or-tumors': null,
    'arthritis-osteoporosis': null,
    aids: null,
    'sexually-transmitted-disease': null,
    'taking-medication': null,
  },
  'health-concerns': [],
  'medical-attendant-details': {
    'medical-institution': null,
    'hospital-phone': null,
    'doctor-first-names': null,
    'doctor-surname': null,
    'doctor-cell-phone': null,
    'contact-doctor': null,
  },
  'payment-method': {
    'debit-order': null,
    'stop-order': null,
    'mobile-wallet': null,
  },
  'payment-start-date': null,
  'payment-frequency': {
    monthly: null,
    quarterly: null,
    annual: null,
    'bi-annual': null,
  },
  'payer-person': {
    myself: null,
    'my-spouse': null,
  },
  'payer-person-identification': {
    'first-names': null,
    surname: null,
    'date-of-birth': null,
    'idpassport-number': null,
    'id-type': null,
  },
  'payment-bank-details': {
    'account-holder-name': null,
    'account-type': null,
    'account-entity-name': null,
    'account-branch-name': null,
    'account-number': null,
  },
  'payment-employment-details': {
    'employer-organisation': null,
    'employee-number': null,
  },
  'payer-signature': null,
  'mobile-wallet-details': {
    'mobile-wallet-network-provider': null,
    'mobile-wallet-number': null,
  },
  documents: {
    'id-document': [],
  },
  signaturedocument: {
    signature: [],
  },
  'confirmation-signature': null,
  'acceptance-signature': null,
  'application-acceptance-date': null,
  'application-accepted': null,
}
